import React from 'react'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
    sortBySelectContainer: {
        marginTop: '0.55rem',
        width: '100% ',
        borderRadius: 5,
        color: '#222222',
        [theme.breakpoints.up('sm')]: {
            marginTop: 0,
        },
    },
    sortBySelect: {
        fontSize: 16,
        height: '3rem',
        backgroundColor: '#F4F4F4',
        borderRadius: 5,
        '&:hover': {
            border: 'none',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
        },
    },
    sortBySelectMenu: {
        '& ul': {
            padding: 0,
        },
    },
    sortBySelectMenuItem: {
        padding: '14px 16px',
        fontSize: 16,
        color: '#592163',
    },
}))

const SortByComponent = ({ items, currentRefinement, refine, createURL }) => {
    const classes = useStyles()

    return (
        <FormControl
            variant="outlined"
            className={classes.sortBySelectContainer}
        >
            <Select
                id={'sort-by'}
                className={classes.sortBySelect}
                MenuProps={{ classes: { paper: classes.sortBySelectMenu } }}
                value={currentRefinement}
                onChange={(event) => refine(event.target.value)}
            >
                {items.map((item) => (
                    <MenuItem
                        className={classes.sortBySelectMenuItem}
                        key={item.value}
                        value={item.value}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default SortByComponent
